/**
 * Meeting & Booking service.
 */
import apiClient from './apiClient';

// ==================== Meetings ====================

export const scheduleMeeting = async (tutorId, meetingDate, durationMinutes) => {
    return apiClient.post(
        `/meetings/schedule?tutor_id=${tutorId}&meeting_date=${meetingDate}&duration_minutes=${durationMinutes}`
    );
};

export const getMyMeetings = async () => {
    return apiClient.get('/meetings/my');
};

export const updateMeetingStatus = async (meetingId, status) => {
    return apiClient.put(`/meetings/${meetingId}/status?status=${status}`);
};

// ==================== Bookings ====================

export const createBooking = async (bookingData) => {
    const { tutor_id, booking_date, time_slot, duration_hours, subject, notes } = bookingData;
    const params = new URLSearchParams({
        tutor_id,
        booking_date,
        time_slot,
        duration_hours,
        subject,
    });
    if (notes) params.append('notes', notes);
    return apiClient.post(`/bookings/create?${params.toString()}`);
};

export const getMyBookings = async () => {
    return apiClient.get('/bookings/my');
};

export const getBookingById = async (bookingId) => {
    return apiClient.get(`/bookings/${bookingId}`);
};

export const updateBookingStatus = async (bookingId, status) => {
    return apiClient.put(`/bookings/${bookingId}/status?status=${status}`);
};

// ==================== Messaging ====================

export const sendMessage = async (receiverId, message) => {
    return apiClient.post(
        `/messages/send?receiver_id=${receiverId}&message=${encodeURIComponent(message)}`
    );
};

export const getMessages = async (otherUserId) => {
    return apiClient.get(`/messages?other_user_id=${otherUserId}`);
};

// ==================== Organizations (public browse) ====================

export const getOrganizations = async (search = '', params = {}) => {
    const queryParams = new URLSearchParams();
    if (search) queryParams.append('search', search);
    if (params.user_lat != null) queryParams.append('user_lat', params.user_lat);
    if (params.user_lng != null) queryParams.append('user_lng', params.user_lng);
    if (params.sort_by) queryParams.append('sort_by', params.sort_by);
    return apiClient.get(`/organizations?${queryParams.toString()}`);
};

export const getOrganizationById = async (id) => {
    return apiClient.get(`/organizations/${id}`);
};

// ==================== Contact form (public) ====================

export const submitContact = async (contactData) => {
    return apiClient.post('/contact', contactData);
};

// ==================== Public booking (legacy) ====================

export const createPublicBooking = async (bookingData) => {
    return apiClient.post('/bookings', bookingData);
};

export const getPublicBookingById = async (id) => {
    return apiClient.get(`/bookings/${id}`);
};
